import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { contentArticleTitleOptions } from '@rich-text/contentful-content-article-rich-text'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: '72px',
  height: '72px',
  objectFit: 'contain',
  alt: '',
}

const ContentfulContentArticleRefreshPictoRight: Utils.EntryFC<
  Queries.ContentfulContentArticleRefreshPictoRightFragment
> = ({
  content: { image, contentArticleTitle: title, subtitle },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div
    className="flex w-full flex-col px-2 py-8 tablet:flex-row tablet:py-10"
    {...entryInspectorProps()}
  >
    <div
      className="max-w-[72px] tablet:mr-8"
      {...fieldInspectorProps({
        fieldId: 'image',
      })}
    >
      <AssetOptionsContext.Provider value={assetOptions}>
        <Entry
          content={image}
          mapping={{
            [ContentType.ContentfulAsset]: ContentfulAsset,
          }}
        />
      </AssetOptionsContext.Provider>
    </div>
    <div>
      <RichText
        {...fieldInspectorProps({
          fieldId: 'title',
        })}
        content={title}
        options={contentArticleTitleOptions}
      />
      <RichText
        className="mt-2"
        {...fieldInspectorProps({
          fieldId: 'subtitle',
        })}
        content={subtitle}
        options={defaultRichTextFieldOptionsDeprecated}
      />
    </div>
  </div>
)

export const query = graphql`
  fragment ContentfulContentArticleRefreshPictoRight on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    contentArticleTitle: title {
      ...ContentfulContentArticleTitle
    }
    subtitle {
      ...ContentfulContentArticleSubtitle
    }
    image {
      ...ContentfulDefaultAsset
    }
    contentLinkText
    contentLinkUrl
  }
`

export default withDisplayName(
  ContentfulContentArticleRefreshPictoRight,
  'ContentfulContentArticleRefreshPictoRight'
)
